import { render, staticRenderFns } from "./teamPage.vue?vue&type=template&id=4e2b5ddc&scoped=true&"
import script from "./teamPage.vue?vue&type=script&lang=js&"
export * from "./teamPage.vue?vue&type=script&lang=js&"
import style0 from "./teamPage.vue?vue&type=style&index=0&id=4e2b5ddc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2b5ddc",
  null
  
)

export default component.exports